export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		yesLabel: {
			type: String,
			default: 'Ja'
		},
		noLabel: {
			type: String,
			default: 'Nee'
		}
	},

	components: {

	},

	mounted() {

	},

	data() {
		return {
			yes: false,
			no: false,
		};
	},

	computed: {
		resolvedYesLabel() {
			return this.readProp('yesLabel') || 'Ja';
		},
		resolvedNoLabel() {
			return this.readProp('noLabel') || 'Nee';
		},
		vModel: {
			get() {
				return this.context._value || '';
			}
		}
	},

	methods: {
		readProp(name) {
			const context = this.context;
			if (context) {
				if (context[name] !== undefined && context[name] !== '') return context[name];
				if (context.node?.props?.[name] !== undefined && context.node.props[name] !== '') return context.node.props[name];
				if (context.attrs?.[name] !== undefined && context.attrs[name] !== '') return context.attrs[name];
			}
			if (this[name] !== undefined && this[name] !== null && this[name] !== '') return this[name];
			return undefined;
		},

		emitValue(value) {
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input(value);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input(value);
			}
		},
		onYesInput(val) {
			if(val) {
				this.emitValue('true');
				this.no = false;
			} else if(!val && !this.no) {
				this.emitValue('');
			}
		},
		onNoInput(val) {
			if(val) {
				this.emitValue('false');
				this.yes = false;
			} else if(!val && !this.yes) {
				this.emitValue('');
			}
		},
	},

	watch: {
		vModel(val) {
			if(!val || !val.length)	{
				this.yes = false;
				this.no = false;
			}
		}
	}
};
